import { StringUtil } from '@nomidio/common';

export enum DomainRegistrationUrlStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export function DomainRegistrationUrlStatusPresentation(status: DomainRegistrationUrlStatus): string {
  switch (status) {
    case DomainRegistrationUrlStatus.Active:
      return 'Active';
    case DomainRegistrationUrlStatus.Inactive:
      return 'Not Active';
    default:
      console.warn(`Mapping not handled for type '${status}' falling back to value`);
      return StringUtil.toPresentationFormat(status);
  }
}
